import { isDefinedString, reduce } from "et3-type-guards";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import UserImageStatus from "./UserImageStatus";
import UserImageArrows from "./UserImageArrows";
import { CAMERA_SOLID } from "../../../../../../constants/picker-entries-constants";
import UserImageBanner from "./UserImageBanner";
import {
  DETAILS_IMAGE_WIDTH,
  DETAILS_PAGER_ROW_HEIGHT
} from "../details-box-constants";

const UserImage = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const squareImageSize = DETAILS_IMAGE_WIDTH * unitX;
  const userID = getUserAdvancedStore().currentUserId.get();
  const pictures = reduce(
    () => getUserAdvancedStore().userData.get(userID).pictures,
    []
  );
  const currentIndex = reduce(
    () => getUserAdvancedStore().userAlbumIndex.get(),
    0
  );
  const { source } = getUserAdvancedStore().getImageData(
    pictures[currentIndex]
  );
  let currentSource = CAMERA_SOLID;
  if (pictures.length > 0) {
    currentSource = isDefinedString(source) ? source : CAMERA_SOLID;
  }
  const moreThanOnePicture = pictures.length > 0;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={DETAILS_IMAGE_WIDTH}
      height={0}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{ flexShrink: 0 }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={DETAILS_IMAGE_WIDTH}
        height={0}
        fDirection="column-reverse"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          position: "relative",
          height: squareImageSize,
          minHeight: squareImageSize
        }}
        onClick={() => {}}
      >
        <UserImageBanner currentSource={currentSource} />
        <UserImageStatus />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={DETAILS_IMAGE_WIDTH}
        height={DETAILS_PAGER_ROW_HEIGHT}
        fDirection="column"
        alignItems="stretch"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <UserImageArrows
          moreThanOnePicture={moreThanOnePicture}
          currentIndex={currentIndex}
          imageArray={pictures}
          onNextPress={() => {
            const nextIndex = currentIndex + 1;
            if (nextIndex > pictures.length - 1) {
              getUserAdvancedStore().userAlbumIndex.set(pictures.length - 1);
              return;
            }
            getUserAdvancedStore().userAlbumIndex.set(nextIndex);
          }}
          onPreviousPress={() => {
            const previousIndex = currentIndex - 1;
            if (previousIndex <= 0) {
              getUserAdvancedStore().userAlbumIndex.set(0);
              return;
            }
            getUserAdvancedStore().userAlbumIndex.set(currentIndex - 1);
          }}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default UserImage;
